import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Content from '../Content/Content';
import Feedback from '../Feedback/Feedback';
import Notificator from '@mos-cat/notificator';

import { sendFeedback } from '../../resources/metrics';

import LogoIcon from '../../assets/Logo.svg';
import Print from '../../assets/Print.svg';

import './Success.pcss';

const InfoItems = ({ isDenial }) => {
  if (isDenial) {
    return (
      <ol className="FinalStep__List">
        <li>
          Заявление будет зарегистрировано в течение 3 часов. Отслеживать его
          статус вы можете в{' '}
          <a
            className="Link"
            href="https://my.mos.ru/my/#/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Личном кабинете
          </a>{' '}
          на Портале{' '}
          <a
            className="Link"
            href="https://www.mos.ru"
            rel="noopener noreferrer"
            target="_blank"
          >
            mos.ru
          </a>
          .
        </li>
        <li>
          В течение 24 часов после регистрации вы можете отозвать апелляцию.
        </li>
        <li>
          Информация о несоответствии бланков ответов/аудиозаписей устных
          ответов будет направлена в региональный центр обработки информации
          города Москвы.
        </li>
      </ol>
    );
  }

  return (
    <ol className="FinalStep__List">
      <li>
        Заявление будет зарегистрировано в течение 3 часов. Отслеживать его
        статус вы можете в{' '}
        <a
          className="Link"
          href="https://my.mos.ru/my/#/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Личном кабинете
        </a>{' '}
        на Портале{' '}
        <a
          className="Link"
          href="https://www.mos.ru"
          rel="noopener noreferrer"
          target="_blank"
        >
          mos.ru
        </a>
        .
      </li>
      <li>
        В течение 24 часов после регистрации вы можете отозвать апелляцию.
      </li>
      <li>
        В течение 2-х рабочих дней вам будут предоставлены:
        <ul className="FinalStep__List-list">
          <li>
            экспертное заключение, содержащее обоснование по оцениванию
            выполненных заданий
          </li>
          <li>
            ссылка на онлайн-чат, в котором вы можете получить разъяснения по
            экспертному заключению
          </li>
          <li>ссылка на онлайн-трансляцию заседания апелляционной комиссии</li>
        </ul>
      </li>
    </ol>
  );
};

// typograf-enable
const Success = ({ action, goToFirstStep, serviceNumber }) => {
  const isDenial = action === 'denial';
  const title = isDenial
    ? 'Заявление успешно отправлено'
    : 'Апелляция успешно отправлена';
  const feedbackTitle = isDenial
    ? 'Подача заявления о несоответствии'
    : 'Подача апелляции на результаты ГИА (ЕГЭ, ОГЭ, ГВЭ)';

  return (
    <div className="Result__Wrapper">
      <div className="Success" />
      <Content>
        <div className="Result__Print">
          <LogoIcon className="Result__Print-logo" />
          <h1 className="Result__Title">
            Подача апелляции о несогласии с выставленными баллами
            государственной итоговой аттестации (ЕГЭ, ОГЭ, ГВЭ)
          </h1>
        </div>
        <Content.Title>{title}</Content.Title>
        {serviceNumber && (
          <div className="Success__Number-wrapper">
            <Content.Text>
              {`Номер вашей заявки `}
              <span className="Success__Number">{serviceNumber}</span>
              <Print
                className="Success__Print-icon Result__NoPrint"
                onClick={() => window.print()}
              />
            </Content.Text>
          </div>
        )}
        <Content.Text>
          Все введенные сведения будут проверены на корректность. В случае
          положительного результата проверки заявление будет зарегистрировано в
          течение 3 часов с момента подачи.
        </Content.Text>
        <Content.Button>
          <Button
            primary
            onClick={() => {
              goToFirstStep();
              window.scrollTo(0, 0);
            }}
            className="Success__Button"
          >
            Подать другую апелляцию
          </Button>
        </Content.Button>
        <Content.Subtitle>Что дальше</Content.Subtitle>
        <Content.Text>
          <InfoItems isDenial={isDenial} />
        </Content.Text>
        {isDenial ? (
          <Content.Text>
            По всем дополнительным вопросам вы можете обратиться в региональный
            центр обработки информации города Москвы по телефону{' '}
            <a
              className="Link"
              rel="noopener noreferrer"
              href="tel:+74996539450"
            >
              +7 499 653-94-50
            </a>
            .
          </Content.Text>
        ) : (
          <Content.Text>
            <div className="FinalStep__List--onlineChats">
              <p className="Result__Paragraph">
                Продолжительность онлайн-чата – не более 20 минут.
              </p>
              <p className="Result__Paragraph Result__Paragraph--attention">
                Обратите внимание, что в случае удовлетворения апелляции
                количество ранее выставленных баллов может измениться как в
                сторону увеличения, так и в сторону уменьшения количества
                баллов.
              </p>
            </div>
          </Content.Text>
        )}
        <div className="Result__Print Result__PrintInfo">
          <p className="Result__PrintAdditional">
            Подача апелляции на результаты ГИА
          </p>
          <p className="Result__PrintLink">
            www.mos.ru/services/podat-apellyatsiyu-na-rezultaty-gia/
          </p>
        </div>
        <Notificator.Provider>
          <Feedback
            title="Оцените удобство сервиса"
            onClickFormSubmitButton={({ commentary }) =>
              sendFeedback(commentary, feedbackTitle)
            }
            onRatingStarClick={({ rating }) =>
              sendFeedback(rating, feedbackTitle)
            }
          />
        </Notificator.Provider>
        <div className="Result__NoPrint">
          <Content.Subtitle>Полезно знать</Content.Subtitle>
        </div>
        <Content.Link>
          <a
            className="Link Content__Link"
            href="https://mos.ru/otvet-obrazovanie/kak-zapisat-rebenka-v-shkolu/"
          >
            Как перевести ребенка в другую школу
          </a>
        </Content.Link>
        <Content.Link>
          <a
            className="Link Content__Link"
            href="https://mos.ru/otvet-obrazovanie/kak-uznat-raspisanie-ege-oge-i-gve/"
          >
            Как узнать расписание ЕГЭ, ОГЭ и ГВЭ
          </a>
        </Content.Link>
        <Content.Link>
          <a
            className="Link Content__Link"
            href="https://mos.ru/otvet-obrazovanie/kak-perevesti-bally-za-ege-i-oge-v-pyatiballnuyu-shkalu/"
          >
            Как перевести баллы за ЕГЭ и ОГЭ в пятибалльную шкалу
          </a>
        </Content.Link>
        <Content.Link>
          <a
            className="Link Content__Link"
            href="https://mos.ru/search?category=instruction&hostApplied=false&page=1&q="
          >
            Все инструкции
          </a>
        </Content.Link>
      </Content>
    </div>
  );
};

Success.propTypes = {
  action: PropTypes.string.isRequired,
  serviceNumber: PropTypes.string.isRequired,
  goToFirstStep: PropTypes.func.isRequired,
};

export default Success;
